import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const createCredentials = createAsyncThunk('credentials/createCredentials',
  async (payload, { rejectWithValue }) => {
    try {
      const url = api.credentials.create;
      const response = await axiosPrivate.post(url, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const createCredentialsSlice = createSlice({
  name: 'createCredentials',
  initialState: {
    createCredentials: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(createCredentials.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(createCredentials.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.createCredentials = action.payload;
        })
      .addCase(createCredentials.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default createCredentialsSlice.reducer;